import { Injectable } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class SnackbarService {
  constructor(private snackBar: MatSnackBar) { }
  openFromComponent(component: any, configs?: any): Observable<any> {
    const snackbarRef = this.snackBar.openFromComponent(component,
      configs
    );
    return snackbarRef.afterDismissed();
  }
}
